<form [formGroup]="notificationForm">
  <h2>Should we send a text to the patient and/or provider?</h2>
  <div class="form-row">
    <mat-slide-toggle formControlName="alert_provider">Provider </mat-slide-toggle>
    <mat-slide-toggle formControlName="alert_patient">Patient </mat-slide-toggle>
  </div>
</form>
